import {useState} from "react";
import ButtonsText from "../../../../../../../components/Button/ButtonText";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import {TextDrugNSAID} from "./TextDrugNSAID"


export default function NSAID() {
    
    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};

return(
<>      

    <ButtonsText onClick={handleOpen} name='NSAID' size='large' color='common.white' />
    
    <CustomDialog open={open} onClose={handleClose}

        title="NSAID - PGx Recommendation"
        content={ <TextDrugNSAID />}

        />

</>
)}